import { Box, BoxProps } from "@chakra-ui/react";

import { MapResult } from "@/api";
import { Legend } from "@/api/accurate-types";

import { LegendDiscrete } from "./legend-discrete";
import { LegendGradient } from "./legend-gradient";
import { LegendPercentages } from "./legend-percentages";

interface ReportLegendProps extends BoxProps {
  mapResult: MapResult;
  isAboveMap?: boolean;
}

export function ReportLegend({ mapResult, isAboveMap, ...rest }: ReportLegendProps) {
  if (!mapResult.legend) return null;
  const { unit, percentages } = mapResult;
  const { colormap_type, labels, legend, name } = mapResult.legend as Legend;
  return (
    <Box {...rest} w={isAboveMap && colormap_type === "discrete" ? "fit-content" : rest.w}>
      {(() => {
        if (percentages?.length) return <LegendPercentages percentages={percentages} />;

        if (colormap_type === "gradient")
          return (
            <LegendGradient legend={legend} legendId={name} unit={unit} withLabel isHorizontal />
          );

        if (colormap_type === "discrete")
          return <LegendDiscrete isAboveMap legend={legend} labels={labels} />;

        return null;
      })()}
    </Box>
  );
}
